import React, { useState, useEffect } from "react";
import "./BlogPost.scss";
import { Link, useParams } from "react-router-dom";
import { PortableText } from "@portabletext/react";
import { client } from "../../sanity/client";
import { Helmet } from "react-helmet-async";
import { urlForImage } from "../../sanity/image";
import SocialShareButton from "../../components/SocialShareButton";

const BlogPost = () => {
  const [blogData, setBlogData] = useState({});
  const { slug } = useParams();

  useEffect(() => {
    const fetchData = async () => {
      const query = `*[_type == "post" && slug.current == "${slug}"]{
    _id,
    title,
    slug,
    coverImage,
    "authorName": author->name,
    "authorImage": author->image,
    description,
    publishedAt,
    body,
    }`;
      const params = { slug };
      const posts = await client.fetch(query, params);

      if (posts && posts.length > 0) {
        setBlogData(posts[0]);
      }
    };

    fetchData();
  }, [slug]);

  const publishedDate = new Date(blogData?.publishedAt);
  const options = { month: "long", day: "numeric", year: "numeric" };
  const formattedDate = publishedDate.toLocaleDateString("en-US", options);
  const PortableTextComponent = {
    types: {
      image: ({ value }) => <img src={urlForImage(value).url()} alt="blog" />,
    },
  };

  return (
    <>
      <Helmet>
        <title>Blogs - Radiksez</title>
        <meta
          name="description"
          content="Read our latest blogs on software development, quality assurance, social media management, and AI & ML validation."
        />
        <link rel="canonical" href="https://radiksez.com/blogs" />
      </Helmet>
      <section className="section blogPosts">
        <article className="blogPosts__container container">
          <div className="blogPosts__container--header">
            <div className="back-container">
              <div className="back">
                <Link to="/blogs">
                  &larr;
                  <span>Go Back</span>
                </Link>
              </div>
              <h1>{blogData.title}</h1>
            </div>
            {blogData.coverImage && (
              <figure className="">
                <img
                  src={urlForImage(blogData.coverImage).url()}
                  alt="blog"
                  width={392}
                  height={240}
                  title="Radiksez blog image"
                />
              </figure>
            )}
          </div>

          <div className="blogPosts__container--details">
            <div className="blogPosts__container--details-wrapper">
              <div className="details__author">
                <h3>POST BY</h3>
                <div className="details__author-profile">
                  {blogData.authorImage && ( // Conditional rendering for author image
                    <img
                      src={urlForImage(blogData.authorImage).url()}
                      alt="author"
                      width={72}
                      height={72}
                      title="Radiksez blog author"
                    />
                  )}

                  <p>{blogData.authorName}</p>
                </div>
              </div>

              <div className="details__published">
                <h3>PUBLISHED ON</h3>
                <p>{formattedDate}</p>
              </div>

              <div className="details__category">
                <h3>CATEGORY</h3>
                <button type="button">
                  <span>UI Design</span>
                </button>
              </div>

              <div className="details__time">
                <h3>READ TIME</h3>
                <p>3 Min</p>
              </div>
            </div>
          </div>
        </article>
      </section>

      <section className="section blogPosts__body">
        <article className="blogPosts__body--container container">
          <SocialShareButton />

          <div className="blogPosts__body--container-content">
            <PortableText
              value={blogData.body}
              components={PortableTextComponent}
            />
          </div>
        </article>
      </section>

      {/* <section className="section blogPosts__related">
        <article className="blogPosts__related--container container">
          <div className="blogPosts__related--container-header">
            <h3>See Our</h3>
            <h2>Related Blogs</h2>
          </div>

          <div className="blogPosts__related--container-content">
            {relatedPosts.map((relatedPost) => {
              return <BlogCard key={relatedPost._id} blogPosts={relatedPost} />;
            })}
          </div>
        </article>
      </section> */}
    </>
  );
};

export default BlogPost;
